import   React            ,
       { useEffect        ,
         useState         }  from "react";
import   ReactDOM            from "react-dom";

import   styles              from "./VideoCommentsBar.module.scss";

import { getVideoComments ,
         VideoCommentRow  }  from "../../../backendServices/moderationManagment/api_videoComments";

const STATUS_LABEL: Record<string, string> = { approved: 'Publié', pending: 'À valider', rejected: 'Refusé' };

const when = (d: Date | null) =>
  d && !isNaN(d.getTime()) ? d.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '';

interface Props {
  videoId : number;
  adminId : number | undefined;
}

/**
 * Compteur de commentaires d'une vidéo, au-dessus de sa fiche dans le Dashboard, et
 * bouton qui ouvre la liste : auteur, adresse IP à l'envoi (renvoyée au seul
 * super-admin ; vide pour les commentaires d'avant le 2026-10-18), date, statut, texte.
 */
const VideoCommentsBar: React.FC<Props> = ({ videoId, adminId }) => {
  const [ count    , setCount    ] = useState<number | null>(null);
  const [ comments , setComments ] = useState<VideoCommentRow[]>([]);
  const [ error    , setError    ] = useState('');
  const [ open     , setOpen     ] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setCount(null); setError('');
    if (!adminId) { setError('Compte non identifié.'); return; }
    getVideoComments(adminId, videoId).then(r => {
      if (cancelled) return;
      setError(r.error); setCount(r.count); setComments(r.comments);
    });
    return () => { cancelled = true; };
  }, [videoId, adminId]);

  return (
    <div className={styles.bar}>
      <span>
        Commentaires : <strong>{count === null ? '…' : count}</strong>
        {error && <span className={styles.error}> — {error}</span>}
      </span>
      <button type="button" className={styles.button} disabled={!count} onClick={() => setOpen(true)}>
        Lire les commentaires
      </button>

      {open && ReactDOM.createPortal(
        <div className={styles.overlay} onClick={() => setOpen(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.header}>
              <span>Commentaires ({count})</span>
              <button type="button" className={styles.close} onClick={() => setOpen(false)} title="Fermer">✕</button>
            </div>
            <div className={styles.list}>
              {comments.map(c => (
                <div key={c.id} className={styles.item}>
                  <div className={styles.meta}>
                    <strong>{c.author}</strong>
                    <span>IP : {c.ip ?? '—'}</span>
                    <span>{when(c.creationDate)}</span>
                    <span className={c.status === 'approved' ? undefined : styles.flag}>{STATUS_LABEL[c.status] ?? c.status}</span>
                  </div>
                  <div className={styles.text}>{c.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default VideoCommentsBar;
